import React, { Component } from "react";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";
import { withRouter } from "react-router-dom";

import PageWrapper from "./ui/PageWrapper";

const Wrapper = styled.div`
  padding: 0 10px;
  display: grid;
  @media only screen and (min-width: 480px) {
    padding: 0 50px;
  }
  @media only screen and (min-width: 900px) {
    grid-template-columns: 300px 1fr 100px;
  }
`;
const Title = styled.div`
  font-size: 48px;
  margin-bottom: 1em;
`;
const Image = styled.img`
  width: 100%;
  margin-bottom: 20px;
  opacity: 0;
  &.loaded {
    opacity: 1;
    transition: opacity 0.3s;
  }
`;
const Nav = styled.div`
  cursor: pointer;
  font-size: 24px;
  display: inline-block;
  margin-right: 20px;
  &:hover {
    color: #fa0068;
  }
`;
const Description = styled.div`
  a {
    text-decoration: none;
    &:hover {
      color: #fa0068;
      padding-bottom: 2px;
      border-bottom: 1px solid #fa0068;
    }
  }
`;

class Piece extends Component {
  state = {};
  componentDidMount() {
    const { piece, config } = this.props;
    const index = config.pieces.findIndex(p => p.url === piece.url);
    this.setState({ index });

    fetch(`../photos/${piece.url}/${piece.description}`)
      .then(response => {
        return response.text();
      })
      .then(text => {
        this.setState({ description: text });
      })
      .catch(err => {
        console.log(err);
      });
  }
  goToPiece = i => {
    const { config } = this.props;

    let index = this.state.index + i;
    if (index < 0) index = config.pieces.length - 1;
    else if (index > config.pieces.length - 1) index = 0;

    const url = this.props.config.pieces[index].url;
    this.props.history.push(`/piece/${url}`);
  };
  onLoad = e => {
    // animates the image in for softer loading
    e.target.className += " loaded";
  };
  componentWillMount() {
    document.addEventListener("keydown", this.onKeyPress);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeyPress);
  }
  onKeyPress = e => {
    if (e.key === "ArrowRight") this.goToPiece(1);
    else if (e.key === "ArrowLeft") this.goToPiece(-1);
  };
  render() {
    const { piece } = this.props;
    return (
      <PageWrapper>
        <Wrapper>
          <div>
            <Title>{piece.name}</Title>
            <Description>
              <ReactMarkdown source={this.state.description} />
            </Description>
            <div>
              <Nav onClick={() => this.goToPiece(-1)}>{`<`}</Nav>
              <Nav onClick={() => this.goToPiece(1)}>{`>`}</Nav>
            </div>
          </div>

          <div>
            {piece.photos.map((p, i) => (
              <Image
                key={i}
                src={`../photos/${piece.url}/${p}`}
                onLoad={this.onLoad}
              />
            ))}
          </div>
        </Wrapper>
      </PageWrapper>
    );
  }
}

export default withRouter(Piece);



// WEBPACK FOOTER //
// ./src/components/Piece.js